import React from 'react';
import { useStore } from 'effector-react';
import { $isCn } from '@stores/langStores';
import ImgPC from './img-pc.png';
import ImgPCE from './img-pc-en.png';
import ImgM from './img-mobile.png';
import ImgME from './img-mobile-en.png';

interface Props {
  isMobile: boolean;
  className?: string;
}

function TourTipImage({ isMobile, className }: Props) {
  const isCn = useStore($isCn);
  const getSrc = () => {
    if (isCn) {
      return isMobile ? ImgM : ImgPC;
    }
    return isMobile ? ImgME : ImgPCE;
  };
  return <img className={className} src={getSrc()} alt="" />;
}

export default TourTipImage;
